export enum StepsIdEnum {
  LOCATION = 0,
  TYPE,
  INFORMATION,
  ADDRESSES,
  PREMISE,
  REVIEW,
  ACKNOWLEDGE
}

export enum StepsCodeEnum {
  LOCATION = 'LOCATION',
  TYPE = 'TYPE',
  INFORMATION = 'INFORMATION',
  ADDRESSES = 'ADDRESSES',
  PREMISE = 'PREMISE',
  REVIEW = 'REVIEW',
  ACKNOWLEDGE = 'ACKNOWLEDGE'
}

export enum StepsResidentialTitleEnum {
  LOCATION = 'Service Address',
  TYPE = 'Request Type',
  INFORMATION = 'About You',
  ADDRESSES = 'Site Details',
  PREMISE = 'About Your Home',
  REVIEW = 'Review',
  ACKNOWLEDGE = 'Acknowledge'
}

export enum StepsTitleCommercialEnum {
  LOCATION = 'Service Address',
  TYPE = 'Request Type',
  INFORMATION = 'Company Info',
  ADDRESSES = 'Site Details',
  PREMISE = 'About Your Business',
  REVIEW = 'Review',
  ACKNOWLEDGE = 'Acknowledge'
}

export enum StepsTitleMixedUseEnum {
  LOCATION = 'Service Address',
  TYPE = 'Request Type',
  INFORMATION = 'About You\\Company',
  ADDRESSES = 'Site Details',
  PREMISE = 'About Your Home\\Business',
  REVIEW = 'Review',
  ACKNOWLEDGE = 'Acknowledge'
}
export enum StepsSubDivisionTitleEnum {
  LOCATION = 'Service Address',
  TYPE = 'Request Type',
  INFORMATION = 'About You',
  ADDRESSES = 'Site Details',
  PREMISE = 'About Your Home',
  REVIEW = 'Review',
  ACKNOWLEDGE = 'Acknowledge'
}

export enum StepsDefaultTitleEnum {
  LOCATION = 'Service Address',
  TYPE = 'Request Type',
  INFORMATION = 'About You',
  ADDRESSES = 'Site Details',
  PREMISE = 'About Your Premise',
  DATA = 'Project Data',
  REVIEW = 'Review',
  ACKNOWLEDGE = 'Acknowledge'
}

export enum StepsRouteEnum {
  LOCATION = 'location',
  TYPE = 'type',
  INFORMATION = 'information',
  ADDRESSES = 'addresses',
  PREMISE = 'premise',
  REVIEW = 'review',
  ACKNOWLEDGE = 'acknowledge'
}
